import React from 'react';
import {
  Button,
  Card,
  Checkbox,
  Col,
  Divider,
  InputNumber,
  Modal,
  Radio,
  Row,
  Space,
  Table,
  Typography,
  notification,
} from 'antd';
import { ModalProps } from 'antd/lib/modal/Modal';
import styled from 'styled-components';

import {
  FormLabel,
  Loading,
  ScreenMask,
} from 'components/common';
import {
  COMMON_ERR_MSG_DEFAULT_DISPLAY_DURATION,
  LOADING_ICON_SIZE1,
} from 'constants/config';
import {
  fetchPackDetailByNum,
  markPackPicked,
  markPackPickedDirectly,
} from 'services/prepack';

interface Props extends ModalProps {
  markInfo: StringKAnyVPair;
  onHide: Function;
  pickStatusLabel: Function;
};

const DialogBody = styled(Space)`
  max-height: calc(100vh - 200px);
  overflow-y: auto;

  & .ant-input-number {
    //border-color: #5d87f0;
    box-shadow: 0 0 0 1px rgba(51, 95, 226, 0.2);
    border-radius: 5px;
    border-right-width: 1px !important;
    outline: 0;
  }

  & .ant-input-number-handler-wrap {
    opacity: 1;
  }

  & .checked-row-radio {
    margin-right: 0;
  }
`;

const MarkShipDialog = (props: Props) => {
  const TARGET_LOCATION_CODE = '$Pack';
  const { useEffect, useState } = React;
  const [inited, setInited] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [manualAdjust, setManualAdjust] = useState(true);
  const [packDetail, setPackDetail] = useState<StringKAnyVPair>({});
  //const [fromTableVersion, setFromTableVersion] = useState(0);

  const locationColumns = [
    {
      title: 'Location(Qty)',
      dataIndex: 'locationCode',
      onHeaderCell: () => ({style: {textAlign: 'center' as 'center'}}),
      render(value: any, record: any) {
        return `${record.locationCode}(${record.quantity})`;
      },
    },
    {
      onHeaderCell: () => ({style: {textAlign: 'center' as 'center'}}),
      title: 'LOT#',
      dataIndex: 'lotNumber',
    },
    {
      //align: 'right' as 'right',
      title: 'Picking',
      dataIndex: 'pickedQty',
      onCell(record: any, rowIdx: any) {
        return {
          style: {padding: 0, width: '25%'},
        };
      },
      onHeaderCell: () => ({style: {textAlign: 'center' as 'center'}}),
      render(value: any, record: any) {
        return (
          <InputNumber
            max={0}
            //min={0 - record.quantity}
            step={1}
            style={{border: 'none', width: '100%'}}
            value={record.pickingQty}
            onChange={val => onPicking(val, record)}
          />
        );
      },
    },
    {
      //align: 'right' as 'right',
      title: 'Total',
      dataIndex: 'quantity',
      onCell: () => ({style: {textAlign: 'right' as 'right'}}),
      onHeaderCell: () => ({style: {textAlign: 'center' as 'center'}}),
      render(value: any, record: any) {
        return record.quantity + record.pickingQty;
      },
    },
  ];

  const pickTableColumns = [
    {
      title: 'SKU',
      dataIndex: 'sku',
      onHeaderCell: () => ({style: {textAlign: 'center' as 'center'}}),
    },
    {
      title: 'UOM',
      dataIndex: 'uom',
      onHeaderCell: () => ({style: {textAlign: 'center' as 'center'}}),
    },
    {
      //align: 'right' as 'right',
      title: 'UOM Rate',
      dataIndex: 'uomRate',
      onCell: () => ({style: {textAlign: 'right' as 'right'}}),
      onHeaderCell: () => ({style: {textAlign: 'center' as 'center'}}),
    },
    {
      //align: 'right' as 'right',
      title: 'Ordered',
      dataIndex: 'requestQty',
      onCell: () => ({style: {textAlign: 'right' as 'right'}}),
      onHeaderCell: () => ({style: {textAlign: 'center' as 'center'}}),
    },
    {
      //align: 'right' as 'right',
      title: 'Picked',
      dataIndex: 'pickedQty',
      onHeaderCell: () => ({style: {textAlign: 'center' as 'center'}}),
      onCell: () => ({style: {textAlign: 'right' as 'right'}}),
    },
    {
      //align: 'right' as 'right',
      onCell: () => ({style: {textAlign: 'right' as 'right'}}),
      onHeaderCell: () => ({style: {textAlign: 'center' as 'center'}}),
      title: 'Picking',
      render(value: any, record: any) {
        return getItemPickingNumber(record);
      },
    },
    {
      title: '',
      dataIndex: 'checked',
      onCell: () => ({style: {textAlign: 'center' as 'center'}}),
      render(value: any, record: any) {
        return (
          <Row justify="center">
            <Radio
              className="checked-row-radio"
              checked={record.checked}
              onChange={evt => onCheckPickItem(record, evt)}
              onClick={evt => evt.stopPropagation()}
            />
          </Row>
        );
      },
    },
  ];

  const toColumns = [
    {
      title: 'Location(Qty)',
      dataIndex: 'locationCode',
      onHeaderCell: () => ({style: {textAlign: 'center' as 'center'}}),
      render(value: any, record: any) {
        return `${record.locationCode}(${record.quantity})`;
      },
    },
    {
      //align: 'right' as 'right',
      title: 'Picking',
      dataIndex: 'pickingQty',
      onCell: () => ({style: {textAlign: 'right' as 'right'}}),
      onHeaderCell: () => ({style: {textAlign: 'center' as 'center'}}),
    },
    {
      //align: 'right' as 'right',
      onCell: () => ({style: {textAlign: 'right' as 'right'}}),
      onHeaderCell: () => ({style: {textAlign: 'center' as 'center'}}),
      title: 'Total',
      dataIndex: 'total',
    },
  ];

  const closeDialog = () => {
    props.onHide();
  };

  const dialogFooter = () => {
    return (
      <Row
        justify="space-between"
      >
        <Button
          onClick={closeDialog}
        >
          Cancel
        </Button>
        <Space>
          <Checkbox
            checked={!manualAdjust}
            onChange={onSwitchManualAdjust}
          >
            Continue without manually adjustment
          </Checkbox>
          <Button
            disabled={manualAdjust && !isAllItemPicked()}
            onClick={markPicked}
            type="primary"
          >
            Mark as Picked
          </Button>
        </Space>
      </Row>
    );
  };

  const getItemPickingNumber = (record: StringKAnyVPair) => {
    //let picking = 0;
    let picking = record.pickedQty;

    (record.locations || []).forEach((l: any) => {
      if (l.locationCode !== TARGET_LOCATION_CODE) {
        picking = picking - l.pickingQty;
      }
    });

    return picking;
  };

  // eslint-disable-next-line
  const getPackDetailByNum = async (packNum: number) => {
    setIsLoading(true);

    try {
      const res = await fetchPackDetailByNum(packNum);

      if (res && typeof res === 'object') {
        //console.log('r', props.markInfo, res);
        if (Array.isArray(res.pickLines)) {
          res.pickLines.forEach((l: any) => {
            l.checked = false;

            if (Array.isArray(l.locations)) {
              l.locations.forEach((location: any) => {
                location.pickingQty = 0;
              });
            }
          });
        }

        setPackDetail(res);
      }
    } catch(e) {
      notification.error({
        message: `Fetch pack information error: ${e}`,
        duration: COMMON_ERR_MSG_DEFAULT_DISPLAY_DURATION,
      });
    } finally {
      setIsLoading(false);
    }
  };

  const getPickItemBySku = (sku: string) => {
    if (packDetail && Array.isArray(packDetail.pickLines)) {
      return packDetail.pickLines.find(p => p.sku === sku);
    }
  };

  const getPickItemTableRowClass = (record: StringKAnyVPair) => {
    const pickingNumber = getItemPickingNumber(record);
    const ret: string[] = [];

    if (pickingNumber === record.requestQty) {
      ret.push('match-row');
    } else if (record.checked) {
      ret.push('ant-table-selected-row');
    }

    return ret.join(' ');
  };

  const isAllItemPicked = () => {
    return !!packDetail && Array.isArray(packDetail.pickLines) && packDetail.pickLines.every(l => getItemPickingNumber(l) === l.requestQty);
  };

  const onCheckPickItem = (record: StringKAnyVPair, evt: any) => {
    packDetail.pickLines.forEach((pl: any) => pl.checked = false);
    record.checked = evt.target.checked;
    setPackDetail({...packDetail});
    //evt.stopPropagation();
  };

  const onCheckPickRow = (record: StringKAnyVPair) => {
    const chk = !record.checked;

    packDetail.pickLines.forEach((pl: any) => pl.checked = false);
    record.checked = chk;
    setPackDetail({...packDetail});
  };

  const onPicking = (val: number, record: any) => {
    const pick = getPickItemBySku(record.sku);

    if (pick) {
      const pickingNumber = getItemPickingNumber(pick);

      if (pickingNumber + (record.pickingQty - val) <= pick.requestQty) {
        //console.log('ch', val, record);
        record.pickingQty = val;
        //record.quantity += val;
        setPackDetail({...packDetail});
        //setFromTableVersion(fromTableVersion + 1);
      } else {
        notification.warning({
          message: 'The picking count has been full',
        });
      }
    }
  };

  const onSwitchManualAdjust = (evt: any) => {
    setManualAdjust(!evt.target.checked);
  };

  const markPicked = () => {
    if (manualAdjust) {
      markPickedManually();
    } else {
      markPickedDirectly();
    }
  };

  const markPickedDirectly = async () => {
    setIsLoading(true);
    try {
      const res = await markPackPickedDirectly(props.markInfo.fulfillmentPackNum);
      console.log('res', res);
      props.markInfo.pickStatus = 1;
      closeDialog();
    } catch(e) {
      notification.error({
        message: `Marked error: ${e}`,
        duration: COMMON_ERR_MSG_DEFAULT_DISPLAY_DURATION,
      });
    } finally {
      setIsLoading(false);
    }
  };

  const markPickedManually = async () => {
    const pickData: StringKAnyVPair[] = [];

    packDetail.pickLines.forEach((pl: StringKAnyVPair) => {
      if (Array.isArray(pl.locations)) {
        pl.locations.forEach((l: StringKAnyVPair) => {
          pickData.push({
            fulfillmentPackLineNum: pl.fulfillmentPackLineNum,
            locationNum: l.locationNum,
            sku: l.sku,
            pickQty: 0 - l.pickingQty,
            lotNumber: l.lotNumber,
            uom: pl.uom,
            uomRate: pl.uomRate,
          });
        });
      }
    });

    if (pickData.length > 0) {
      console.log('d', pickData);
      setIsLoading(true);
      try {
        const res = await markPackPicked(props.markInfo.fulfillmentPackNum, pickData);
        console.log('res', res);
        props.markInfo.pickStatus = 1;
        closeDialog();
      } catch(e) {
        notification.error({
          message: `Marked error: ${e}`,
          duration: COMMON_ERR_MSG_DEFAULT_DISPLAY_DURATION,
        });
      } finally {
        setIsLoading(false);
      }
    }
  };

  const renderFromSku = (items: StringKAnyVPair[]) => {
    const item = items.find(item => item.checked);

    return item ? (
      <Divider>{`Picking: ${item.sku}`}</Divider>
    ) : null;
  };

  const renderFromLocations = (items: StringKAnyVPair[]) => {
    const locations: StringKAnyVPair[] = [];

    items.forEach(item => item.locations.forEach((l: StringKAnyVPair) => item.checked && l.locationCode !== TARGET_LOCATION_CODE && locations.push(l)));

    return locations.length > 0 ? (
      <Space
        direction="vertical"
        size={[8, 8]}
        style={{width: '100%'}}
      >
        <div>
          <FormLabel>From</FormLabel>
        </div>
        <Table
          bordered
          columns={locationColumns}
          dataSource={locations}
          //key={`from-table-${fromTableVersion}`}
          pagination={false}
          rowKey={record => `${record.inventoryNum}-${record.locationNum}`}
        />
      </Space>
    ) : null;
  };

  // eslint-disable-next-line
  const renderPackLines = (lines: StringKAnyVPair[]) => {
    return lines.map(pl => (
      <Card
        extra={<Space><Space><FormLabel>Requested</FormLabel><Typography.Text>{pl.requestQty}</Typography.Text></Space><Space><FormLabel>Packed</FormLabel><Typography.Text>{pl.packQty}</Typography.Text></Space></Space>}
        key={pl.prepackSKU}
        size="small"
        title={pl.prepackSKU} 
      >
        {pl.packLineItems.map((item: StringKAnyVPair) => (
          <Card
            size="small"
            type="inner"
            key={item.fulfillmentPackLineNum}
            // headStyle={!confirmAble && item.packQty === item.requestQty ? {backgroundColor: theme['@success-color'] }: undefined}
            title={item.sku}
            style={{ marginBottom: 10 }}
          >
            <Row style={{ width: '100%' }}>
              <Col span={8}>
                <FormLabel>UPC</FormLabel>
                {item.upc || ''}
              </Col>
              <Col span={8}>
                <FormLabel>Product Name</FormLabel>
                {item.productTitle}
              </Col>
              <Col span={8}>
                <FormLabel>Requested</FormLabel>
                {`${item.requestQty} (${item.componentQuantity} * ${ pl.requestQty})`}
              </Col>
              <Col span={8}>
                <FormLabel>Picked</FormLabel>
                {item.pickedQty}
              </Col>
              <Col span={8}>
                <FormLabel>Packed</FormLabel>
                {`${item.componentQuantity * pl.packQty} (${item.componentQuantity} * ${pl.packQty})`}
              </Col>
            </Row>
          </Card>
        ))}
      </Card>
    ));
  };

  const renderPickItems = (items: StringKAnyVPair[]) => {
    return (
      <Table
        bordered
        columns={pickTableColumns}
        dataSource={items}
        onRow={record => ({onClick: () => onCheckPickRow(record)})}
        pagination={false}
        //rowClassName={(record: any) => record.checked ? 'match-row' : ''}
        rowClassName={getPickItemTableRowClass}
        rowKey="fulfillmentPackLineNum"
      />
    );
  };

  const renderToLocation = (items: StringKAnyVPair[]) => {
    const packData: StringKAnyVPair[] = [];
    let item: StringKAnyVPair | null = null;
    let location: StringKAnyVPair | null = null;
    //const item = items.find(p => p.checked && Array.isArray(p.locations) && p.locations.find((l: StringKAnyVPair) => l.locationCode === TARGET_LOCATION_CODE));
    items.forEach(e => e.locations
      .forEach((l: StringKAnyVPair) => {
        if (e.checked && l.locationCode === TARGET_LOCATION_CODE) {
          item = e;
          location = l;
        }
      }
    ));

    if (item && location) {
      const pickQty = getItemPickingNumber(item);
      // note: can not use location directly
      // because state data must be update by set method
      packData.push({
        //pack: TARGET_LOCATION_CODE,
        locationCode: (location as any).locationCode,
        pickingQty: pickQty,
        //quantity: item.requestQty,
        quantity: (location as any).quantity,
        total: (location as any).quantity + pickQty,
      });
    }

    return packData.length > 0 ? (
      <Space
        direction="vertical"
        size={[8, 8]}
        style={{width: '100%'}}
      >
        <div>
          <FormLabel>To</FormLabel>
        </div>
        <Table
          bordered
          columns={toColumns}
          dataSource={packData}
          pagination={false}
          rowKey={record => `${record.inventoryNum}-${record.locationNum}`}
        />
      </Space>
    ) : null;
  };

  useEffect(() => {
    if (!inited) {
      getPackDetailByNum(props.markInfo.fulfillmentPackNum);
      setInited(true);
    }
  }, [getPackDetailByNum, inited, props]);

  return (<>
    <Modal
      centered
      footer={dialogFooter()}
      onCancel={closeDialog}
      maskClosable={false}
      title={props.title || 'Change Pick Status'}
      visible={props.visible || true}
      width={900}
    >
      <DialogBody
        direction="vertical"
        size={[8, 16]}
        style={{width: '100%'}}
      >
        <Row>
          <Col span={12}>
            <FormLabel>ERP Request#</FormLabel>
            {props.markInfo.packCode}
          </Col>
          <Col span={12}>
            <FormLabel>Pick Status</FormLabel>
            {props.pickStatusLabel(props.markInfo.pickStatus)}
          </Col>
        </Row>
        {manualAdjust && renderPickItems(packDetail.pickLines)}
        {manualAdjust && packDetail && Array.isArray(packDetail.pickLines) && (<>
          {renderFromSku(packDetail.pickLines)}
          {renderFromLocations(packDetail.pickLines)}
          {renderToLocation(packDetail.pickLines)}
        </>)}
        {/*packDetail.pack && Array.isArray(packDetail.pack.lines) && renderPackLines(packDetail.pack.lines)*/}
      </DialogBody>
    </Modal>
    {isLoading && (
      <ScreenMask>
        <Loading size={LOADING_ICON_SIZE1} />
      </ScreenMask>
    )}
  </>);
};

export default MarkShipDialog;
